import {ValueObject} from '@s-ui/domain'

export class UploadAttachmentUserRequest extends ValueObject {
  constructor({channelId, file}) {
    UploadAttachmentUserRequest.validate({channelId, file})
    super()
    this._channelId = channelId
    this._file = file
  }

  static create({channelId, file}) {
    return new UploadAttachmentUserRequest({channelId, file})
  }

  static validate({channelId, file}) {
    const checkParamExists = param => param !== undefined && param !== null

    if (!checkParamExists(channelId)) {
      throw new Error('channelId is required')
    }

    if (!checkParamExists(file)) {
      throw new Error('file is required')
    }
  }

  getChannelId() {
    return this._channelId
  }

  getFile() {
    return this._file
  }

  toJSON() {
    return {
      channelId: this._channelId,
      file: this._file
    }
  }
}
